import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(homepages)/register/page.js");
